import { MapSearchResult } from '../../models/map-listing.model';
import { PolygonFilter } from '../../models/polygon-filter.model';
import { createAction, props } from '@ngrx/store';
import { RealEstateSearch } from '../../models/real-estate-search.model';
import { RealEstate, RealEstateSearchResult } from '../../models/real-estate.model';
import { RealEstateSortState } from '../states/real-estate.state';
import { AdReport, ReportSearch } from '../../models/ad-report.model';
import { CreateReport } from '../../models/create-report.model';

export const searchRealEstates = createAction(
  '[Search] Search Real Estates',
  props<{ query: RealEstateSearch }>()
);

export const searchRealEstatesSuccess = createAction(
  '[Search] Search Real Estates Success',
  props<{ propertyResults: RealEstateSearchResult | undefined }>()
);

export const searchRealEstatesFailure = createAction(
  '[Search] Search Real Estates Failure',
  props<{ error: string }>()
);

export const searchMapRealEstates = createAction(
  '[Search] Search Map Real Estates',
  props<{ mapQuery: RealEstateSearch }>()
);

export const searchMapRealEstatesSuccess = createAction(
  '[Search] Search Map Real Estates Success',
  props<{ propertyMapResults: MapSearchResult | undefined }>()
);

export const searchMapRealEstatesFailure = createAction(
  '[Search] Search Map Real Estates Failure',
  props<{ error: string }>()
);

export const getTopRealEstates = createAction('[RealEstates] Get Top Real Estates');
export const getTopRealEstatesSuccess = createAction(
  '[RealEstates API] Get Top Real Estates Success',
  props<{ topPropertyResults: RealEstateSearchResult }>()
);
export const getTopRealEstateFailure = createAction(
  '[RealEstates API] Get Top Real Estates Failure',
  props<{ error: string }>()
);

export const getRealEstate = createAction(
  '[RealEstates] Get Real Estate',
  props<{ realEstateId: number }>()
);
export const getRealEstateSuccess = createAction(
  '[RealEstates API] Get Real Estate Success',
  props<{ realEstate: RealEstate }>()
);
export const getRealEstateFailure = createAction(
  '[RealEstates API] Get Real Estate Failure',
  props<{ error: string }>()
);

export const addRealEstate = createAction(
  '[RealEstates] Add RealEstate',
  props<{ formData: FormData }>()
);
export const addRealEstateSuccess = createAction(
  '[RealEstates API] Add Real Estate Success',
  props<{ realEstate: RealEstate }>()
);
export const addRealEstateFailure = createAction(
  '[RealEstates API] Add Real Estate Failure',
  props<{ error: string }>()
);

export const updateRealEstate = createAction(
  '[RealEstates] Update Real Estate',
  props<{ formData: FormData; realEstateId: number }>()
);
export const updateRealEstateSuccess = createAction(
  '[RealEstates API] Update Real Estate Success',
  props<{ realEstate: RealEstate }>()
);
export const updateRealEstateFailure = createAction(
  '[RealEstates API] Update Real Estate Failure',
  props<{ error: string }>()
);

export const upgradeRealEstate = createAction(
  '[RealEstates] Upgrade Real Estate',
  props<{ realEstateId: number }>()
);
export const upgradeRealEstateSuccess = createAction(
  '[RealEstates API] Upgrade RealEstate Success',
  props<{ realEstate: RealEstate }>()
);
export const upgradeRealEstateFailure = createAction(
  '[RealEstates API] Upgrade Real Estate Failure',
  props<{ error: string }>()
);

export const likeRealEstate = createAction(
  '[RealEstates] Like Real Estate',
  props<{ userId: number; realEstateId: number; isLike: boolean }>()
);
export const likeRealEstateSuccess = createAction(
  '[RealEstates API] Like Real Estate Success',
  props<{ realEstate: RealEstate; userId: number }>()
);
export const likeRealEstateFailure = createAction(
  '[RealEstates API] Like Real Estate Failure',
  props<{ error: string }>()
);

export const setRealEstateSold = createAction(
  '[RealEstates] Set Real Estate Sold',
  props<{ realEstateId: number }>()
);
export const setRealEstateSoldSuccess = createAction(
  '[RealEstates API] Set Real Estate Sold Success',
  props<{ realEstate: RealEstate }>()
);
export const setRealEstateSoldFailure = createAction(
  '[RealEstates API] Set Real Estate Sold Failure',
  props<{ error: string }>()
);

export const removeRealEstate = createAction(
  '[RealEstates] Remove Real Estate',
  props<{ id: number }>()
);
export const removeRealEstateSuccess = createAction(
  '[RealEstates API] Remove Real Estate Success',
  props<{ id: number }>()
);
export const removeRealEstateFailure = createAction(
  '[RealEstates API] Remove Real Estate Failure',
  props<{ error: string }>()
);

export const updateSearchForm = createAction(
  '[Search] Update Form',
  props<{ form: RealEstateSearch }>()
);

export const changeRealEstateSort = createAction(
  '[RealEstates] Change Sort',
  props<{ active: RealEstateSortState['active']; direction: RealEstateSortState['direction'] }>()
);

export const changeRealEstatePage = createAction(
  '[RealEstates] Change Page',
  props<{ pageIndex: number }>()
);

export const changeRealEstatePageSize = createAction(
  '[RealEstates] Change Page Size',
  props<{ pageSize: number }>()
);

export const updateRealEstateReportSearchForm = createAction(
  '[RealEstates] Update Report Search Form',
  props<{ form: ReportSearch }>()
);

export const searchRealEstateReports = createAction(
  '[RealEstates] Search RealEstate Reports',
  props<{ reportQuery: ReportSearch }>()
);

export const searchRealEstateReportsSuccess = createAction(
  '[RealEstates] Search RealEstate Reports Success',
  props<{ realEstateReports: AdReport[] }>()
);

export const searchRealEstateReportsFailure = createAction(
  '[RealEstates] Search RealEstate Reports Failure',
  props<{ error: string }>()
);

export const addRealEstateReport = createAction(
  '[RealEstates] Add RealEstate Report',
  props<{ entity: string; id: number; model: CreateReport }>()
);
export const addRealEstateReportSuccess = createAction(
  '[RealEstates API] Add RealEstate Report Success',
  props<{ report: AdReport }>()
);
export const addRealEstateReportFailure = createAction(
  '[RealEstates API] Add RealEstate Report Failure',
  props<{ error: string }>()
);

export const updateRealEstateReport = createAction(
  '[RealEstates] Update RealEstate Report',
  props<{ reportId: number; status: string }>()
);
export const updateRealEstateReportSuccess = createAction(
  '[RealEstates API] Update RealEstate Report Success',
  props<{ report: AdReport }>()
);
export const updateRealEstateReportFailure = createAction(
  '[RealEstates API] Update RealEstate Report Failure',
  props<{ error: string }>()
);
export const loadRealEstateViewPreference = createAction('[View] Load Real Estate View Preference');

export const setRealEstateMapView = createAction(
  '[View] Set Real Estate Map View',
  props<{ isRealEstateMapView: boolean }>()
);

export const toggleRealEstateMapView = createAction('[View] Toggle Real Estate Map View');

export const setRealEstatePolygon = createAction(
  '[RealEstates] Set Polygon',
  props<{ polygon: PolygonFilter | null }>()
);
export const resetRealEstateSearch = createAction('[RealEstates] Reset Search');
export const retryRealEstateSearch = createAction('[RealEstates] Retry Search');

export const clearRealEstatePolygon = createAction('[RealEstate] Clear Polygon');

export const ensureRealEstateList = createAction('[RealEstate] Ensure Initial List');
